import { http } from '../../config/axios'

export default function postClienteDocumento(idCliente: string, dto: any): Promise<any> {
  return http
    .post(`api/client/documento/${idCliente}`, dto)
    .then((res) => res.data)
    .catch((error) => {
      console.error('Erro postClienteDocumento', error)
      throw Error(error.response?.data || 'Erro ao salvar documento')
    })
}
